module.exports = __webpack_public_path__ + "media/ขอเซ็ท.4d87ad97.mp3";